import { createAsyncThunk } from "@reduxjs/toolkit";
import { removeToken, setToken } from "../../utils/helperFunction";
import UserApi from "../services/user";

export const LoginThunk = createAsyncThunk('auth/login', async(payload:any) => {
    
    try{
        const response = await UserApi.LoginService(payload);
        setToken(response.data.accessToken)
        return response.data
    }
    catch(e){
        return Promise.reject(e)
    }
})

export const signOut = createAsyncThunk('auth/signOut', async () => {
    removeToken();
});